const initDoctorPage = () => {
    if (window.innerWidth <= 1024) {
        const selector = "[data-timetable-slider]";
        const config = new CarouselConfig();
        config.sliderSelector = selector;
        config.cellAlign = CellAlign.center;
        config.contain = true;
        config.autoPlay = false;
        config.wrapAround = false;
        config.showArrows = false;
        config.activateCustomButtons = false;
        config.showDots = false;
        config.groupCells = false;
        config.adaptiveHeight = false;
        config.imagesLoaded = true;
        const responsiveCarousel = new ResponsiveCarousel();
        responsiveCarousel.initCarousel(config);
    }
};
